(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.ticking = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      // Placeholder per evitare salti quando le barre aggiuntive spariscono
      this.placeholder = document.createElement('div');
      this.placeholder.classList.add('header-scroll-placeholder');
      this.placeholder.style.display = 'none';
      this.header.insertAdjacentElement('beforebegin', this.placeholder);

      // Cache della placeholder height — aggiornata solo al resize, non ad ogni scroll
      this.cachedPlaceholderHeight = 0;
      this.updatePlaceholderHeight();

      this.resizeObserver = new ResizeObserver(() => {
        this.setHeaderHeight();
        this.updatePlaceholderHeight();
      });
      this.resizeObserver.observe(this.header);

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      // passive: true — il browser non aspetta il callback per scorrere
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    updatePlaceholderHeight() {
      // Salta l'aggiornamento quando le barre sono nascoste dal CSS (scrolled-past-header):
      // in quel caso il ResizeObserver scatterebbe e azzererebbe erroneamente la cache
      if (this.header.classList.contains('scrolled-past-header')) return;
      let height = 0;
      this.header.querySelectorAll('.header-top-bar, .header-secondary-bar, .header-bottom-bar').forEach(bar => {
        if (getComputedStyle(bar).display !== 'none') height += bar.offsetHeight;
      });
      this.cachedPlaceholderHeight = height;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.resizeObserver?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    ensurePlaceholder() {
      if (this.placeholder && !this.header.classList.contains('scrolled-past-header')) {
        if (this.cachedPlaceholderHeight > 0) {
          this.placeholder.style.height = `${this.cachedPlaceholderHeight}px`;
          this.placeholder.style.display = 'block';
        }
      }
    }

    onScroll() {
      // Debounce: un solo rAF per frame, indipendentemente da quanti eventi scroll arrivano
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.handleScroll();
        this.ticking = false;
      });
    }

    handleScroll() {
      const scrollTop = window.scrollY;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.header.classList.contains('scrolled-past-header')) {
          this.ensurePlaceholder();
          this.header.classList.add('scrolled-past-header');
        }
        if (this.preventHide) return;
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.header.classList.contains('scrolled-past-header')) {
          this.ensurePlaceholder();
          this.header.classList.add('scrolled-past-header');
        }
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.bottom) {
        this.resetWithSlideUp();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      if (this.predictiveSearch) this.predictiveSearch.close(false);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    resetWithSlideUp() {
      if (this.isResetting) return;

      if (this.headerIsAlwaysSticky) {
        // Header sempre sticky: rimuovi solo scrolled-past-header con animazione sulla secondary bar
        this.header.classList.remove('scrolled-past-header');
        if (this.placeholder) this.placeholder.style.display = 'none';
        return;
      }

      if (this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden')) {
        this.isResetting = true;
        this.header.classList.add('shopify-section-header-hidden');
        setTimeout(() => {
          this.reset();
        }, 150);
      } else {
        this.reset();
      }
    }

    reset() {
      // Rimuovi sempre scrolled-past-header e il placeholder, indipendentemente da headerIsAlwaysSticky
      this.header.classList.remove('shopify-section-header-hidden', 'animate', 'scrolled-past-header');
      if (this.placeholder) this.placeholder.style.display = 'none';
      this.isResetting = false;
      if (!this.headerIsAlwaysSticky) {
        this.header.classList.remove('shopify-section-header-sticky');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Secondary bar: open dropdown on hover
  document.querySelectorAll('.header-secondary-bar header-menu').forEach((menu) => {
    const details = menu.querySelector(':scope > details');
    if (!details) return;

    let closeTimer;

    menu.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    });

    menu.addEventListener('mouseleave', () => {
      closeTimer = setTimeout(() => details.removeAttribute('open'), 100);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
